// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bb07b48f","977":"a4345789"}[chunkId] + ".chunk.js";
};